import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/index.vue'
import logins from '@/views/logins.vue'
import register from '@/views/register.vue'
import retrieves from '@/views/retrieves.vue'
import livevideo from '@/views/livevideo.vue' 
import spotvideo from '@/views/spotvideo.vue'
import baopay from '@/views/baopay.vue'
import agreement from '@/views/agreement.vue'
import classbox from '@/router/class.js'
import mechanism from '@/router/mechanism.js'
import teacher from '@/router/teacher.js'
import orders from '@/router/orders.js'
import search from '@/router/search.js'
import information from '@/router/information.js'
import my from '@/router/my.js'
import ordercenter from '@/router/ordercenter.js'
import follow from '@/router/follow.js'
import settings from '@/router/settings.js'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/index',
    name: 'index',
    component: () => import( '@/views/index.vue')
  },
  {
    path: '/logins',
    name: 'logins',
    component: () => import( '@/views/logins.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import( '@/views/register.vue')
  },
  {
    path: '/retrieves',
    name: 'retrieves',
    component: () => import( '@/views/retrieves.vue')
  },
  {
    path: '/livevideo',
    name: 'livevideo',
    component: () => import( '@/views/livevideo.vue')
  },
  {
    path: '/spotvideo',
    name: 'spotvideo',
    component: () => import( '@/views/spotvideo.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import( '@/views/agreement.vue')
  },
  {
    path: '/baopay',
    name: 'baopay',
    component: () => import( '@/views/baopay.vue')
  },
  ...classbox,
  ...mechanism,
  ...teacher,
  ...orders,
  ...search,
  ...information,
  ...my,
  ...ordercenter,
  ...follow,
  ...settings,
  /*{
    path: '/classlistarr',
    name: 'classlistarr',
    component: () => import( '@/views/classlistarr.vue')
  },
  {
    path: '/detailsclass',
    name: 'detailsclass',
    component: () => import( '@/views/detailsclass.vue')
  }*/
]

const router = new VueRouter({
  routes
})





export default router
